import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})export class ConfirmationServiceService {

  private messageSource = new Subject<{ message: string; imageUrl?: string; callback: () => void; cancelCallback?: () => void }>();
  confirmation$ = this.messageSource.asObservable();

  openConfirmDialog(message: string, callback: () => void, imageUrl?: string, cancelCallback?: () => void) {
    this.messageSource.next({ message, callback, imageUrl, cancelCallback });
  }
}
